import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-amber-50 via-white to-green-50 border-t border-amber-100">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-amber-600 to-green-600">
                <i className="ri-heart-pulse-line text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="font-display text-2xl font-bold text-neutral-800">
                  Lotus Maternal
                </h3>
              </div>
            </div>
            <p className="text-sm text-neutral-600 leading-relaxed mb-5">
              Empowering all families through holistic doula care and compassionate community support.
            </p>

            {/* Instagram — only social icon */}
            <a
              href="https://www.instagram.com/lotus.maternal?igsh=djQxbzN2MjdpNHRv&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-100 to-pink-100 border border-amber-200 rounded-2xl px-4 py-3 hover:from-amber-200 hover:to-pink-200 transition-all group cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gradient-to-br from-amber-500 to-pink-500 group-hover:scale-110 transition-transform">
                <i className="ri-instagram-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-neutral-500 leading-none mb-0.5">Follow us on</p>
                <p className="text-sm font-bold text-neutral-800 leading-none">@lotus.maternal</p>
              </div>
              <i className="ri-arrow-right-up-line text-amber-600 text-sm ml-1"></i>
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display text-lg font-bold text-neutral-800 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/about" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">About</Link></li>
              <li><Link to="/services" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Services</Link></li>
              <li><Link to="/packages" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Packages</Link></li>
              <li><Link to="/blog" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Blog</Link></li>
              <li><Link to="/manual" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Birth Plan</Link></li>
              <li><Link to="/booking" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Book Now</Link></li>
              <li><Link to="/contact" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display text-lg font-bold text-neutral-800 mb-4">Services</h4>
            <ul className="space-y-2.5">
              <li><Link to="/services" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Prenatal Support</Link></li>
              <li><Link to="/services" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Birth Doula</Link></li>
              <li><Link to="/services" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Postpartum Care</Link></li>
              <li><Link to="/services" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">Lactation Support</Link></li>
              <li>
                <a
                  href="https://calendly.com/queenbriebirthworker/30min"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer"
                >
                  Free Consultation
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-lg font-bold text-neutral-800 mb-4">Get in Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line text-amber-700 text-base mt-0.5"></i>
                <a href="tel:9294738867" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer">(929) 473-8867</a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-amber-700 text-base mt-0.5"></i>
                <div>
                  <a href="mailto:info@lotusmaternal.com" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer block">info@lotusmaternal.com</a>
                  <span className="text-xs text-neutral-400">General inquiries</span>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-customer-service-2-line text-amber-700 text-base mt-0.5"></i>
                <div>
                  <a href="mailto:support@lotusmaternal.com" className="text-sm text-neutral-600 hover:text-amber-700 transition-colors cursor-pointer block">support@lotusmaternal.com</a>
                  <span className="text-xs text-neutral-400">Services &amp; programs support</span>
                </div>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-amber-700 text-base mt-0.5"></i>
                <span className="text-sm text-neutral-600">Brooklyn, NY</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-amber-100 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-neutral-500">© 2025 Lotus Maternal. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/contact" className="text-sm text-neutral-500 hover:text-amber-700 transition-colors cursor-pointer">Contact</Link>
            <Link to="/booking" className="text-sm text-neutral-500 hover:text-amber-700 transition-colors cursor-pointer">Book Now</Link>
            <Link to="/admin" className="text-xs text-neutral-400 hover:text-amber-700 transition-colors cursor-pointer">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
